module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/Groupe 24-7ba6285fb02c545c33ccf4541485afca.png";